import { keyframes } from "tss-react";
const bounceIn = keyframes `
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;
const bounceOut = keyframes `
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.8);
  }
`;
const slideInTop = keyframes `
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;
const slideOutTop = keyframes ` 
  from {
    opacity: 1;
    transform: none;
  } 
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
`;
const slideInRight = keyframes `
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;
const slideOutRight = keyframes ` 
  from {
    opacity: 1;
    transform: none;
  } 
  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
`;
const slideInBottom = keyframes `
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;
const slideOutBottom = keyframes ` 
  from {
    opacity: 1;
    transform: none;
  } 
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
`;
const slideInLeft = keyframes `
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;
const slideOutLeft = keyframes ` 
  from {
    opacity: 1;
    transform: none;
  } 
  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
`;
export { bounceIn, bounceOut, slideInTop, slideOutTop, slideInRight, slideOutRight, slideInBottom, slideOutBottom, slideInLeft, slideOutLeft };
//# sourceMappingURL=animation.js.map